import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home'; // Ajusta la ruta según tu estructura
import Aboutp from './Pages/Aboutp';
import Login from './Pages/Login';
import AdminPage from './Pages/AdminPage';
import { AuthProvider } from './Context/AuthContext';
import ProtectedRoute from './Pages/ProtectedRoutes';
import Appointment from './Pages/Appointment';
import Service from './Pages/Service';
import Contact from './Pages/Contact';
import DynamicTitle from './Components/DynamicTitle/DynamicTitle';
import { HelmetProvider } from "react-helmet-async";
import SchemaMarkup from "./Components/SEO/SchemaMarkup";
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/scss/bootstrap.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min'; // Importa Bootstrap JS
import 'jquery';
import '@popperjs/core';
function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
        <DynamicTitle />
          <SchemaMarkup />
          <div className="App">        
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/appointment" element={<Appointment />} />
            <Route path="/about" element={<Aboutp />} />
            <Route path="/services" element={<Service />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
